const baseStyle = {};
const defaultProps = {
    size: 'md'
};
const parts = ['button', 'item', 'list'];
const sizes = {
    md: {
        list: {
            size: 'sm'
        }
    },
    lg: {
        list: {
            size: 'md'
        }
    }
};
const variants = {};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
